import { inject, Injectable, DOCUMENT } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Partner, PARTNERS, NO_PARTNER } from '../../Models/partners';
import { ThemeLoaderService } from '../theme-loader/theme-loader.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerThemeService {
  private document = inject<Document>(DOCUMENT);
  private overlayContainer = inject(OverlayContainer);
  private themeLoader = inject(ThemeLoaderService);
  private titleService = inject(Title);

  applyPartner(partner: Partner | null): void {
    const effectivePartner = partner ?? NO_PARTNER;
    const classList = this.document.body.classList;
    const overlayClassList =
      this.overlayContainer.getContainerElement().classList;
    const favicon = this.document.getElementById('favicon');

    if (effectivePartner.code) {
      classList.add(effectivePartner.class);
      overlayClassList.add(effectivePartner.class);
      if (effectivePartner.code === 'msm') {
        this.themeLoader.init('msm-theme');
      }
    } else {
      this.themeLoader.init(effectivePartner.class ?? 'primary-theme');
      PARTNERS.forEach((p) => {
        if (classList.contains(p.class)) {
          classList.remove(p.class);
        }
        if (overlayClassList.contains(p.class)) {
          overlayClassList.remove(p.class);
        }
      });
    }

    this.titleService.setTitle(effectivePartner.title);
    favicon?.setAttribute('href', `./assets/favicons/${effectivePartner.icon}`);
  }
}
